// @ts-check
import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

const uiSchema = {
  ...titleUI('Institution VA Facility Code'),
  hasVaFacilityCode: yesNoUI({
    title: 'Does your institution have a VA Facility Code?',
    hint: 'A VA Facility Code is 8 characters in length and assigned to institutions with programs approved by VA.',
    errorMessages: {
      required: 'Select ‘yes’ if your institution has a VA Facility Code',
    },
  }),
};

const schema = {
  type: 'object',
  properties: {
    hasVaFacilityCode: yesNoSchema,
  },
  required: ['hasVaFacilityCode'],
};

const updateFormData = (_oldData, formData) => {
  return !formData?.hasVaFacilityCode
    ? {
        ...formData,
        primaryInstitutionDetails: {},
      }
    : formData;
};

export { schema, uiSchema, updateFormData };
